import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { NitroGrids, NitroGrid, NitroPanel, NitroHeading, NitroButton, NitroButtonGroup } from 'nitro-components';
import styled from 'styled-components';

import { isEmpty } from 'lodash';

import { validateFrequency, frequencyComponentsMap, translateSchedule } from './scheduleScheme';

import Recipients from '../../report-edit/components/Recipients';
import { translateRecipients } from '../../report-edit/recipients';

import FilterSection from '../../../../components/filter/FilterSection';

import Container from '../../../../components/layouts/Container';

const Content = styled.section`margin: 40px 0;`;

const Panel = styled.div`
  border: 1px solid ${props => props.theme.color.border};
  border-radius: 2px;
  background-color: ${props => props.theme.color.white};
  padding: 40px 80px;
`;

class Schedule extends Component {
  constructor(props) {
    super(props);
    this.state = {
      schedule: props.schedule,
      recipients: props.recipients,
      isScheduleValidated: false
    };
  }

  componentDidMount() {
    this.setState(
      {
        isScheduleValidated: validateFrequency(this.state.schedule)
      },
      this.setNavigation
    );
  }

  resetSchedule = () => {
    this.setState(
      {
        schedule: translateSchedule([]),
        recipients: {
          to: [],
          cc: [],
          bcc: []
        }
      },
      () => this.goNext()
    );
  };

  setNavigation = () => {
    const removeButton = isEmpty(this.props.schedule[0].value)
      ? null
      : <NitroButton
          action={this.resetSchedule}
          label="REMOVE SCHEDULE"
          labelVariant="base2"
          icon="delete"
          insideIconSize={8}
          size="extraSmall"
        />;
    this.props.setNavigation({
      left: (
        <NitroButton
          action={this.props.navigation.goPrevious}
          labelVariant="secondary"
          label="PREVIOUS"
          size="extraSmall"
          leftIcon="arrow-left"
          leftIconVariant="secondary"
          insideIconSize={8}
        />
      ),
      middle: removeButton,
      right: (
        <NitroButtonGroup layout="horizontal" align="right">
          <NitroButton
            action={this.props.navigation.goNext}
            label="SKIP"
            labelVariant="primary"
            rightIconVariant="primary"
            size="extraSmall"
            rightIcon="arrow-right"
            insideIconSize={8}
          />
          <NitroButton
            disabled={!this.state.isScheduleValidated}
            action={this.goNext}
            label="NEXT"
            variant="primary"
            size="extraSmall"
            rightIcon="arrow-right"
            insideIconSize={8}
          />
        </NitroButtonGroup>
      )
    });
  };

  changeSchedule = (index, filter) => {
    const schedules = this.state.schedule.map(schedule =>
      Object.assign({}, schedule, {
        component: frequencyComponentsMap[schedule.componentType]
      })
    );
    const newSchedule = [...schedules];
    newSchedule[index] = Object.assign({}, newSchedule[index], { ...filter });

    this.setState(
      {
        isScheduleValidated: validateFrequency(newSchedule),
        schedule: newSchedule
      },
      () => this.setNavigation()
    );

    // console.log('new schedule', newSchedule);
    // this.props.actions.setSchedule(newSchedule);
  };

  goNext = () => {
    const repRecipients = this.recipientsRef.data;
    this.props.actions.setSchedule(this.state.schedule);
    this.props.actions.setRecipients(repRecipients);
    this.props.navigation.goNext();
  };

  render() {
    const { actions, username } = this.props;
    const { schedule, recipients } = this.state;

    const schedules = schedule.map(schedule =>
      Object.assign({}, schedule, {
        component: frequencyComponentsMap[schedule.componentType]
      })
    );

    // const changeSchedule = (index, filter) => {
    //   const newSchedule = [...schedules];
    //   newSchedule[index] = Object.assign({}, newSchedule[index], { ...filter });
    //
    //   console.log('new schedule', newSchedule);
    //   actions.setSchedule(newSchedule);
    // };

    // const setRecipients = () => {
    //   actions.setRecipients(this.receipient.data);
    // };

    return (
      <Container>
        <Content>
          <NitroGrids>
            <NitroGrid grid={2}>
              <NitroHeading align="center" variant="secondary" size="3" label="Schedule Frequency" />
              <Panel>
                {schedules.map((filter, index) =>
                  <FilterSection
                    action={this.changeSchedule}
                    key={index}
                    index={index}
                    filters={schedules}
                    filter={filter}
                  />
                )}
              </Panel>
            </NitroGrid>
            <NitroGrid grid={2}>
              <NitroHeading align="center" variant="secondary" size="3" label="Who should recieve this?" />
              <Panel>
                <Recipients ref={ref => (this.recipientsRef = ref)} username={username} recipients={recipients} selected />
              </Panel>
            </NitroGrid>
          </NitroGrids>
        </Content>
      </Container>
    );
  }
}

Schedule.propTypes = {
  actions: PropTypes.object
};

export default Schedule;



// WEBPACK FOOTER //
// ./src/features/scheduling-reports/new-report/Schedule/Schedule.js